// 緊急連絡レベル
export const EMERGENCY_CONTACT_LEVEL_MAP = {
    nppv24: { code: 1, name: "S : NPPV 24h（マスク）" },
    tppv24: { code: 2, name: "A : TPPV 24h（気切）" },
    tppvNightTime: { code: 3, name: "B : TPPV 夜間のみ（気切）" },
    nppvNightTime: { code: 4, name: "C : NPPV 夜間のみ（マスク）" },
    hot24gtOrEqual3l: { code: 5, name: "D：HOT24h（設定値３L以上）" },
    hot24lt3l: { code: 6, name: "E：HOT24h（設定値３L未満）" }
};
export const EMERGENCY_CONTACT_LEVELS = [
    EMERGENCY_CONTACT_LEVEL_MAP.nppv24,
    EMERGENCY_CONTACT_LEVEL_MAP.tppv24,
    EMERGENCY_CONTACT_LEVEL_MAP.tppvNightTime,
    EMERGENCY_CONTACT_LEVEL_MAP.nppvNightTime,
    EMERGENCY_CONTACT_LEVEL_MAP.hot24gtOrEqual3l,
    EMERGENCY_CONTACT_LEVEL_MAP.hot24lt3l
]

// 性別
export const GENDER_MAP = {
    male: { code: "M", name: "男性" },
    female: { code: "F", name: "女性" }
};

// 感染症種別
export const INFECTION_TYPE_MAP = {
    no: { code: "0", name: "無し" },
    mrsa: { code: "1", name: "MRSA" },
    hcv: { code: "2", name: "HCV" },
    hbv: { code: "3", name: "HBV" },
    wa: { code: "4", name: "Wa" },
    others: { code: "5", name: "その他" }
};

// 直送先種別
export const DIRECT_DESTINATION_TYPE_MAP = {
    unjustifiable: { code: "0", name: "直送不可" },
    patientHome: { code: "1", name: "患者宅" },
    hospital: { code: "2", name: "クリニック" },
    dealerDelivery: { code: "3", name: "ディーラー配送" }
};

// 療法種別
export const THERAPY_TYPE_MAP = {
    nppv: { code: "0", name: "NPPV" },
    tppv: { code: "1", name: "TPPV" },
    hft: { code: "2", name: "HFT" },
    npptHft: { code: "3", name: "NPPV/HFT" },
    tppvHft: { code: "4", name: "TPPV/HFT" },
    hot: { code: "6", name: "HOT" },
};
export const THERAPY_TYPE_STATUSES = [
    THERAPY_TYPE_MAP.nppv,
    THERAPY_TYPE_MAP.tppv,
    THERAPY_TYPE_MAP.hft,
    THERAPY_TYPE_MAP.npptHft,
    THERAPY_TYPE_MAP.tppvHft,
    THERAPY_TYPE_MAP.hot
];

// サマリ用療法種別
export const THERAPY_TYPE_SUMMARY_MAP = {
    breath: { code: 1, name: "呼吸" },
    hot: { code: 2, name: "HOT" },
    breath_hot: { code: 3, name: "呼吸＋HOT併用" },
};
export const THERAPY_TYPE_SUMMARY_STATUSES = [
    THERAPY_TYPE_SUMMARY_MAP.breath,
    THERAPY_TYPE_SUMMARY_MAP.hot,
    THERAPY_TYPE_SUMMARY_MAP.breath_hot,
];

// リースアップ種別
export const LEASEUP_TYPE_MAP = {
    fail: { code: 0, name: "不可"},
    other: { code: 1, name: "その他"},
    cancel: { code: 2, name: "中止"},
    hospitalHandling: { code: 3, name: "医療機関対応"},
    salseOfficeHandling: { code: 4, name: "営業所対応"},
    vendorHandling: { code: 5, name: "業者対応"},
    installTrouble: { code: 6, name: "EncorePro2インストールトラブル"},
    hospitalUnsolicited: { code: 7, name: "医師・医療機関未承諾"},
    heatedHumidifier: { code: 8, name: "加温加湿器"},
    hospitalDelivery: { code: 9, name: "クリニック配送"},
    dealerDelivery: { code: 10, name: "ディーラー配送"},
    patient: { code: 11, name: "患者"},
};
export const LEASEUP_TYPES = Object.values(LEASEUP_TYPE_MAP);

// General task対応
export const GT_STATUS_MAP = {
    remand: {
        code: -10,
        name: "差戻",
    },
    noActionRequired: {
        code: 0,
        name: "対応不要",
    },
    actionRequired: {
        code: 10,
        name: "対応要",
    },
    inProgress: {
        code: 20,
        name: "対応中",
    },
    actionCompleted: {
        code: 2147483647,
        name: "対応完了",
    },
};

export const GT_STATUS_RED_LIST = [
    10, // 対応要
    20, // 対応不要
];
export const GT_ACTION_MAP = {
    noActionRequired: {
      code: 0,
      name: "対応不要",
    },
    actionRequired: {
      code: 1,
      name: "対応要",
    },
};
export const GT_ACTIONS = Object.values(GT_ACTION_MAP);



// WEBPACK FOOTER //
// ./src/utils/patient.js